import { useEffect } from 'react';
import { Tabs, Slot } from 'expo-router';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import * as Notifications from 'expo-notifications';
import { useAuth } from '@/hooks/useAuth';
import { useConversations } from '@/hooks/useConversations';
import { HamburgerDrawer } from '@/components/HamburgerDrawer';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { supabase } from '@/lib/supabase';

function PersonalMenuButton() {
  const { profile, signOut } = useAuth();
  const { totalUnread } = useConversations(profile?.id ?? '');
  return (
    <HamburgerDrawer
      role="personal"
      unreadCount={totalUnread}
      conversationTarget="/(personal)/chat/"
      profileTarget="/(personal)/profile"
      financesTarget="/(personal)/finances"
      myWorkoutTarget="/(personal)/my-workout"
      retentionTarget="/(personal)/retencao"
      onSignOut={signOut}
    />
  );
}

export default function PersonalTabsLayout() {
  const { profile } = useAuth();
  const isDesktop = useIsDesktop();
  const insets = useSafeAreaInsets();
  const bottomPad = Math.max(insets.bottom, 8);

  useEffect(() => {
    if (!profile) return;
    (async () => {
      try {
        const { status } = await Notifications.requestPermissionsAsync();
        if (status !== 'granted') return;
        const tokenObject = await Notifications.getExpoPushTokenAsync();
        await supabase.from('profiles').update({ expo_push_token: tokenObject.data }).eq('id', profile.id);
      } catch {}
    })();
  }, [profile?.id]);

  // Desktop: o shell já é aplicado pelo (personal)/_layout. Aqui só passa o Slot.
  if (isDesktop) {
    return <Slot />;
  }

  return (
    <Tabs screenOptions={{
      tabBarActiveTintColor: '#C8102E',
      headerShown: false,
      tabBarStyle: { height: 56 + bottomPad, paddingBottom: bottomPad, paddingTop: 6 },
    }}>
      <Tabs.Screen
        name="index"
        options={{
          title: 'Início',
          tabBarLabel: 'Início',
          tabBarIcon: ({ color, size }) => <Ionicons name="home-outline" size={size} color={color} />,
          headerShown: true,
          headerRight: () => <PersonalMenuButton />,
          headerRightContainerStyle: { paddingRight: 16 },
        }}
      />
      <Tabs.Screen
        name="students/index"
        options={{
          title: 'Alunos',
          tabBarLabel: 'Alunos',
          tabBarIcon: ({ color, size }) => <Ionicons name="people-outline" size={size} color={color} />,
          headerShown: true,
          headerRight: () => <PersonalMenuButton />,
          headerRightContainerStyle: { paddingRight: 16 },
        }}
      />
      <Tabs.Screen
        name="library/index"
        options={{
          title: 'Exercícios',
          tabBarLabel: 'Exercícios',
          tabBarIcon: ({ color, size }) => <Ionicons name="barbell-outline" size={size} color={color} />,
          headerShown: true,
          headerRight: () => <PersonalMenuButton />,
          headerRightContainerStyle: { paddingRight: 16 },
        }}
      />
    </Tabs>
  );
}
